import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { OfflineSupplierUpsertRequest } from 'src/types/manage-suppliers/OfflineSupplierUpsert';
import axiosInstance from 'src/utils/axios';

const useUpsertOfflineSupplierMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: OfflineSupplierUpsertRequest) => {
      const response = await axiosInstance.post<number>(api.upsertOfflineSupplier, request);
      return response.data;
    },
    // Returned so mutateAsync resolves only after supplier queries have refetched.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.manageSuppliers.root }),
  });
};

export default useUpsertOfflineSupplierMutation;
